import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { NavigationTreeModels } from '../store/models/navigation-tree.model';
import { api } from '../consts/url.const';

@Injectable({
  providedIn: 'root'
})
export class NavigationTreeService {
  constructor(private http: HttpClient) { }

  public getNavigationOrdering(): Observable<NavigationTreeModels.NavigationOrder[]> {
    return this.http.get<NavigationTreeModels.NavigationOrder[]>(api.navigationTree.crud);
  }

  public updateNavigationOrdering(data: Record<string, number>): Observable<any> {
    return this.http.put<any>(api.navigationTree.crud, { data });
  }
}
